import React, { useEffect, useState } from "react";
import "./footer.css";
import footerContent from "./footerData.json";
import { Link, useLocation } from "react-router-dom";
// import packageJson from "../../../package.json";

function Footer() {
  const footerData = footerContent;
  const year = new Date().getFullYear();
  const location = useLocation();
  const [fromFooter, setFromFooter] = useState(false);

  const partnerSiteId = JSON.parse(sessionStorage.getItem("partnerSiteId"));
  const siteId = partnerSiteId?.siteId || "0";

  useEffect(() => {
    const handleScroll = () => {
      const params = new URLSearchParams(location.search);
      const id = params.get("id");
      const hash = location.hash;
      const element = id
        ? document.getElementById(id)
        : hash
        ? document.querySelector(hash)
        : null;

      if (fromFooter) {
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        } else {
          window.scrollTo(0, 0);
        }
        setTimeout(() => setFromFooter(false), 500);
      }
    };

    handleScroll();
  }, [location, fromFooter]);

  const renderFooterLink = (link) => (
    <li key={link.linkName} className="py-1">
      {link.linkUrl.startsWith("http") ? (
        <a
          href={link.linkUrl}
          className="text-underline-hover text-white"
          target="_blank"
          data-discover="true"
          rel="noreferrer"
          onClick={() => setFromFooter(true)}
        >
          {link.linkName}
        </a>
      ) : (
        <Link
          to={link.linkUrl}
          className="text-underline-hover text-white"
          data-discover="true"
          onClick={() => setFromFooter(true)}
        >
          {link.linkName}
        </Link>
      )}
    </li>
  );

  const renderFooterColumn = (data) => (
    <div className="col" key={data.footerName}>
      <h5 className="text-white foot-text text-uppercase bld mb-4">
        {data.footerName}
      </h5>
      <ul className="list-unstyled foot-text">
        {data.footerLinks.map(renderFooterLink)}
      </ul>
    </div>
  );

  return (
    <footer className="footer">
      <div className="container d-md-block d-none pt-5 pb-1 px-3">
        <div className="row">{footerData.map(renderFooterColumn)}</div>
      </div>
      <div className="container px-3 pb-5">
        <div className="navigation d-flex text-md-left text-center justify-content-center nav-footer_terms">
          <ul className="list-inline">
            <li className="list-inline-item">
              <Link
                className="nav-link link-light foot-text"
                to="/vehiclehistory/terms-of-use"
                data-discover="true"
                onClick={() => setFromFooter(true)}
              >
                AutoCheck Terms and Conditions
              </Link>
            </li>
            <li className="list-inline-item">|</li>
            <li className="list-inline-item">
              <a
                className="nav-link link-light foot-text"
                href="http://www.experian.com/corporate/legalterms.html"
                target="_blank"
                data-discover="true"
                rel="noreferrer"
                onClick={() => setFromFooter(true)}
              >
                Experian Terms and Conditions
              </a>
            </li>
            <li className="list-inline-item">|</li>
            <li className="list-inline-item">
              <a
                className="nav-link link-light foot-text"
                href="https://www.experian.com/privacy/auto_check"
                target="_blank"
                data-discover="true"
                rel="noreferrer"
                onClick={() => setFromFooter(true)}
              >
                Privacy Policy
              </a>
            </li>
            <li className="list-inline-item">|</li>
            <li className="list-inline-item">
              <Link
                className="nav-link link-light foot-text"
                to="/vehiclehistory/your-ad-choices"
                data-discover="true"
                onClick={() => setFromFooter(true)}
              >
                Your Ad Choices
              </Link>
            </li>
          </ul>
        </div>
        <div className="d-flex justify-content-center text-white foot-text">
          © Experian {year}. All rights reserved.
        </div>
        {/* <div className="d-flex justify-content-center text-white-50 foot-text mt-2" style={{ fontSize: '0.75rem' }}>
          Version: {packageJson.version} | Build: {process.env.REACT_APP_BUILD_TIME || 'local'}
        </div> */}

        <input
          id="siteID"
          value={siteId}
          type="hidden"
          name="siteID"
          readOnly
        />
      </div>
    </footer>
  );
}

export default Footer;
